import Vue from "vue";

export const RESELLER_EVENT_BUS = new Vue({
  data: () => ({
    reseller: {}
  }),
  computed: {
    resellerDetails: function() {
      return this.reseller
        ? this.reseller.details
          ? JSON.parse(this.reseller.details)
          : {}
        : {};
    }
  }
});
